import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { map as _map, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getFormattedDate as formatDate } from '../../../Utils/Getter';
import { PercentageUsageCard } from '../../Components';

import styles from './FilteredUsersUsage.Styles';

function FilteredUsersUsage({ user, images, onViewGraphsPress, ...props }) {
  const theme = useTheme();
  const renderViewGraphs = period => {
    return (
      <TouchableOpacity
        style={styles.viewGraphsContainerStyle}
        onPress={() => {
          const { id, name, role, type } = user;
          _isFunction(onViewGraphsPress) && onViewGraphsPress({ id, name, role, type }, period);
        }}
      >
        <VFText
          i18nKey={'soho_usage_users_view_graphs_label'}
          style={styles.viewGraphsTextStyle(theme)}
        />
      </TouchableOpacity>
    );
  };
  const { usagePeriods } = user;
  return (
    <View style={styles.containerStyle}>
      {_map(usagePeriods, usagePeriod => {
        const { startDate, endDate, period, usageData } = usagePeriod;
        return (
          <PercentageUsageCard
            title={period}
            renderHeaderRightSection={() => renderViewGraphs(period)}
            date={formatDate({ startDate, endDate, period })}
            usageData={usageData}
            images={images}
            containerStyle={styles.itemContainerStyle}
          />
        );
      })}
    </View>
  );
}

FilteredUsersUsage.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
    type: PropTypes.string,
    usagePeriods: PropTypes.arrayOf(
      PropTypes.shape({
        period: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        usageData: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.string,
            isUnlimited: PropTypes.bool,
            name: PropTypes.string,
            totalAmount: PropTypes.number,
            totalUnits: PropTypes.string,
            usageType: PropTypes.string,
            usedAmount: PropTypes.number,
            usedUnits: PropTypes.string,
            valuePercentage: PropTypes.string,
          }),
        ),
      }),
    ),
  }),
  images: PropTypes.object,
  onViewGraphsPress: PropTypes.func,
};

export default FilteredUsersUsage;
